import API from "shared/services/Api";
import {
  IAreasResponse,
  IGruposResponse,
  IOpcoesValorResponse,
  IValidarSenhaResponse,
  ISaveOrcamentoResponse,
  ISaveOrcamentoPayload,
  IOrcamentosAbertosResponse,
  ILoadOrcamentoResponse,
  IPanProfData,
} from "shared/types/ClinicalBudget";

export const getAreas = async (
  userId: string,
  busca?: string
): Promise<IAreasResponse> =>
  API.get(`/oc/clinical-budget/areas?id=${userId}${busca ? `&busca=${encodeURIComponent(busca)}` : ''}`);

export const getGrupos = async (
  userId: string,
  procId: number
): Promise<IGruposResponse> =>
  API.get(`/oc/clinical-budget/grupos?id=${userId}&proc_id=${procId}`);

export const getOpcoesValor = async (
  userId: string,
  procId: number
): Promise<IOpcoesValorResponse> =>
  API.get(`/oc/clinical-budget/opcoes-valor?id=${userId}&proc_id=${procId}`);

export const validarSenha = async (
  userId: string,
  senha: string
): Promise<IValidarSenhaResponse> =>
  API.post('/oc/clinical-budget/validar-senha', { id: userId, senha });

export const saveOrcamento = async (
  userId: string,
  payload: ISaveOrcamentoPayload
): Promise<ISaveOrcamentoResponse> =>
  API.post('/oc/clinical-budget/save', { id: userId, ...payload });

export const getOrcamentosAbertos = async (
  userId: string,
  pacId: number
): Promise<IOrcamentosAbertosResponse> =>
  API.get(`/oc/clinical-budget/patient/${pacId}/open?id=${userId}`);

export const loadOrcamento = async (
  userId: string,
  idOrc: number,
  pacId?: number
): Promise<ILoadOrcamentoResponse> =>
  API.get(`/oc/clinical-budget/${idOrc}/load?id=${userId}${pacId ? `&pac_id=${pacId}` : ''}`);

export const updateOrcamento = async (
  userId: string,
  payload: ISaveOrcamentoPayload
): Promise<ISaveOrcamentoResponse> =>
  API.post('/oc/clinical-budget/update', { id: userId, ...payload });

export const getPanProf = async (
  userId: string,
  pacId: number
): Promise<{ data: { success: boolean; data: IPanProfData | null }; status: number }> =>
  API.get(`/oc/clinical-budget/patient/${pacId}/pan-prof?id=${userId}`);
